import { render, staticRenderFns } from "./callback.vue?vue&type=template&id=1edd11b8&scoped=true&"
import script from "./callback.vue?vue&type=script&lang=ts&"
export * from "./callback.vue?vue&type=script&lang=ts&"
import style0 from "./callback.vue?vue&type=style&index=0&id=1edd11b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1edd11b8",
  null
  
)

export default component.exports